export default "/img/PK.f60c294729906bc184b82f5851565575.png";